export default __webpack_public_path__ + "1cfc6df97f112bb1727d5c639787c1c0.svg";